import React, { PureComponent } from 'react';
import Select from 'react-select';
import Helmet from 'react-helmet';

import TopMenu from '../../components/TopMenu';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LoadingSpinner from '../../components/LoadingSpinner';

import styles from './styles.module.scss';
import templateStyles from '../../templates/styles.module.scss';
import { INSTDBBUNDLE } from '../../utils/ui-bundle'

const dataUrl = 'https://us-central1-fao-aquastat.cloudfunctions.net/getAquastatInstitutionsDBInt';
const lang = 'EN', defLang = 'EN';


class InstitutionsDatabase extends PureComponent {

    allText = INSTDBBUNDLE.ALL[lang];
    pageSize = 25;
    skip = 0;
    currentPage = 1;

    constructor(props) {
        super(props)
        this.state = {
            institutions: [],
            UnfilteredInstitutions: [],
            instName: '',
            country: '',
            type: '',
            active: '',
            sector: '',
            activity: '',
            dataLoaded: false,
            selectedCountry: [],
            selectedType: [],
            selectedSector: [],
            selectedActivity: [],
            take: this.pageSize,
            numberOfPages: 0,
        };

        this.handleCountrySelected = this.handleCountrySelected.bind(this);
        this.handleTypeSelected = this.handleTypeSelected.bind(this);
        this.handleSectorSelected = this.handleSectorSelected.bind(this);
        this.handleActivitySelected = this.handleActivitySelected.bind(this);
    }

    async componentDidMount() {

        fetch(dataUrl)
        .then(res => res.json())
        .then((data) => {
            this.setState({
                institutions: data.institutions,
                UnfilteredInstitutions: data.institutions,
                country: data.area,
                type: data.type,
                sector: data.sector,
                activity: data.activity,
                dataLoaded: true,
            });
        })
        .catch(console.log);
    }

    filter() {

        if (!this.state.instName && !this.state.country && !this.state.type && !this.state.sector && !this.state.active) {
            this.setState({
                institutions: this.state.UnfilteredInstitutions
            });
        }

        this.setState({
            institutions: this.state.UnfilteredInstitutions.filter(inst =>
                inst.Name.toLowerCase().includes(this.state.instName.toLowerCase())
                && ((this.state.country && this.state.selectedCountry && this.state.selectedCountry.length > 0 && this.state.selectedCountry[0] !== this.allText) ? (inst.area[`NAME_${lang}`] || inst.area[`NAME_${defLang}`]).toLowerCase() === (this.state.selectedCountry[0].toLowerCase()) : true)
                && ((this.state.type && this.state.selectedType && this.state.selectedType.length > 0 && this.state.selectedType[0] !== this.allText) ? (inst.type[`NAME_${lang}`] || inst.type[`NAME_${defLang}`]).toLowerCase().includes(this.state.selectedType[0].toLowerCase()) : true)
                && (this.state.activity && this.state.selectedActivity && this.state.selectedActivity.length > 0 && this.state.selectedActivity[0] !== this.allText ? (inst.activities || []).map(act => (act[`NAME_${lang}`] || act[`NAME_${defLang}`])).join(',').toLowerCase().includes(this.state.selectedActivity[0].toLowerCase()) : true)
                && (this.state.sector && this.state.selectedSector && this.state.selectedSector.length > 0 && this.state.selectedSector[0] !== this.allText ? (inst.sectors || []).map(sct => (sct[`NAME_${lang}`] || sct[`NAME_${defLang}`])).join(',').toLowerCase().includes(this.state.selectedSector[0].toLowerCase()) : true)
            )
        });
    }

    renderTableHeader() {
        return (
            <tr key="header">
                <th>{INSTDBBUNDLE.INST[lang].toUpperCase()}</th>
                <th>{INSTDBBUNDLE.CNTRY[lang].toUpperCase()}</th>
                <th>{INSTDBBUNDLE.TYP[lang].toUpperCase()}</th>
                <th>{`${INSTDBBUNDLE.ACTIVE[lang].toUpperCase()}`}<br/>{`(${INSTDBBUNDLE.YES[lang]}/${INSTDBBUNDLE.NO[lang]})`}</th>
                <th>{INSTDBBUNDLE.SCTR[lang].toUpperCase()}</th>
                <th>{INSTDBBUNDLE.ACTIVITY[lang].toUpperCase()}</th>
            </tr>
        )
    }

    valueFromId = (opts, id) => opts.find(o => o.value === id);

    resetPaging() {
        this.skip = 0;
        this.currentPage = 1;
    }
    
    onSearchByName(event) {
        this.setState({ instName: event.target.value, take: this.pageSize }, () => {
            this.resetPaging();
            this.filter();
        });
    }

    handleCountrySelected({label}) {
        this.setState({ selectedCountry: [label], take: this.pageSize }, () => {
            this.resetPaging();
            this.filter();
        });
    }

    handleTypeSelected({label}) {
        this.setState({ selectedType: [label], take: this.pageSize }, () => {
            this.resetPaging();
            this.filter();
        });
    }

    handleSectorSelected({label}) {
        this.setState({ selectedSector: [label], take: this.pageSize }, () => {
            this.resetPaging();
            this.filter();
        });
    }

    handleActivitySelected({label}) {
        this.setState({ selectedActivity: [label], take: this.pageSize }, () => {
            this.resetPaging();
            this.filter();
        });
    }

    clearSearchCriteria() {
        this.setState(
            {
                instName: '',
                selectedCountry: null,
                selectedType: [this.allText],
                selectedSector: [this.allText],
                selectedActivity: [this.allText],
            }, () => {
            this.filter();
        });
    }

    renderTableData() {

        const availableRecordSize = this.state.institutions.length;
        this.setState({numberOfPages: Math.ceil(availableRecordSize / this.pageSize)});

        if (this.skip >= availableRecordSize) {
            this.skip = availableRecordSize - this.state.take;
        }

        return this.state.institutions.slice(this.skip, this.state.take + this.skip)
            .map((inst) => {
                const { Institution_Id, Name, parent_id, area, type, sectors, activities, Acronym, active, replaced_by } = inst
                return (
                    <tr className={styles} key={Institution_Id}>
                        <td>{Name} {Acronym && (<i>({Acronym})</i>)}
                            {parent_id &&
                                (<span>
                                    <br/>
                                    <i>{INSTDBBUNDLE.UNDER[lang]}: </i> {parent_id}
                                </span>)
                            }
                        </td>
                        <td>{area[`NAME_${lang}`] || area[`NAME_${defLang}`]}</td>
                        <td className={styles.noWrap}>{(type[`NAME_${lang}`] || type[`NAME_${defLang}`]).split('/').join(' / ')}</td>
                        <td>{active.toLowerCase() === 'y' ? INSTDBBUNDLE.YES[lang] : INSTDBBUNDLE.NO[lang]}
                            {(replaced_by !==0 && replaced_by)  && 
                                <span>
                                    <br/>
                                    <i>{INSTDBBUNDLE.REPLACEDBY[lang]}</i>: {this.getInstitutionName(replaced_by)}
                                </span>}
                        </td>
                        <td>{sectors&& sectors.map(sct => (sct[`NAME_${lang}`] || sct[`NAME_${defLang}`])).join(', ')}</td>
                        <td>{activities && activities.map(act => (act[`NAME_${lang}`] || act[`NAME_${defLang}`])).join(', ')}</td>
                    </tr>
                )
            })
    }

    getInstitutionName(institutionId) {
        const institution = this.state.UnfilteredInstitutions.find(inst => inst.Institution_Id === Number(institutionId));
        return institution ? institution.Name : '';
    }
    
    itemsPerPage(size) {
        this.setState({
            take: size
        }, () => this.filter());
    }

    pageSelected(pageNumber) {        
        this.currentPage = pageNumber;
        this.skip = 25 * (pageNumber - 1);
    }

    nextPage() {
        this.skip = 25 * (++this.currentPage - 1);
    }

    previousPage() {
        this.skip = 25 * (--this.currentPage - 1);
    }

    renderMetadata() {
        return (
            <div className={styles.metadata}>
                <div className={styles.pagingInfo}>
                    {this.state.institutions.length} <span>{this.state.institutions.length > 1 ? INSTDBBUNDLE.INSTS[lang] : INSTDBBUNDLE.INST[lang]}</span>
                </div>
                <div className={styles.pagination}>
                    <ul>
                        {(this.currentPage - 1 > 0) && <li className={styles.back}><a href="#" onClick={this.previousPage.bind(this)}>&#60;&#60;</a></li>}
                        {(this.currentPage - 2 > 0) && <li><a href="#" onClick={this.pageSelected.bind(this, this.currentPage - 2)}>{this.currentPage - 2}</a></li>}
                        {(this.currentPage - 1 > 0) && <li><a href="#" onClick={this.pageSelected.bind(this, this.currentPage - 1)}>{this.currentPage - 1}</a></li>}
                        <li className={styles.currentPage}>{this.currentPage}</li>
                        {(this.currentPage + 1 < this.state.numberOfPages) && <li><a href="#" onClick={this.pageSelected.bind(this, this.currentPage + 1)}>{this.currentPage + 1}</a></li>}
                        {(this.currentPage + 2 < this.state.numberOfPages) && <li><a href="#" onClick={this.pageSelected.bind(this, this.currentPage + 2)}>{this.currentPage + 2}</a></li>}
                        {(this.currentPage + 1 < this.state.numberOfPages) && <li className={styles.next}><a  href="#" onClick={this.nextPage.bind(this)}>&#62;&#62;<i className="fa fa-angle-double-right"></i></a></li>}
                    </ul>
                </div>
            </div>
        );
    }

    renderSearchArea() {

        const { selectedCountry, selectedType, selectedSector, selectedActivity, instName } = this.state;

        const countryOptions = this.state.country ? [...[{ label: this.allText, value: this.allText }], ...this.state.country.map(cnt => ({ label: (cnt[`FAO_SHORT_NAME_${lang}`] || cnt[`FAO_SHORT_NAME_${defLang}`]), value: cnt.AREA_ID }))] : [];
        const typeOptions = this.state.type ? [...[{ label: this.allText, value: this.allText }],
                                ...this.state.type.filter(t => t.VALID !== 0)
                                    .sort((cur, pre) => (cur[`NAME_${lang}`] || cur[`NAME_${defLang}`]).localeCompare((pre[`NAME_${lang}`] || pre[`NAME_${defLang}`])))
                                    .map(t => ({ label: (t[`NAME_${lang}`] || t[`NAME_${defLang}`]), value: t.Institution_Type_Id }))] : [];
        const sectorOptions = this.state.sector ? [...[{ label: this.allText, value: this.allText }],
                                ...this.state.sector.sort((cur, pre) => (cur[`NAME_${lang}`] || cur[`NAME_${defLang}`]).localeCompare((pre[`NAME_${lang}`] || pre[`NAME_${defLang}`])))
                                    .map(t => ({ label: (t[`NAME_${lang}`] || t[`NAME_${defLang}`]), value: t.SECTOR_ID }))] : [];
        const activityOptions = this.state.activity ? [...[{ label: this.allText, value: this.allText }],
                                ...this.state.activity
                                    .filter(a => a.VALID !== 0)
                                    .sort((cur, pre) => (cur[`NAME_${lang}`] || cur[`NAME_${defLang}`]).localeCompare((pre[`NAME_${lang}`] || pre[`NAME_${defLang}`])))
                                    .map(a => ({ label: (a[`NAME_${lang}`] || a[`NAME_${defLang}`]), value: a.ACTIVITY_ID }))] : [];

        return (
            <div className={styles.filterWrapper}>
                <div>
                    <label>{INSTDBBUNDLE.FILTERBYINST[lang]}</label>
                    <input type="text" placeholder={INSTDBBUNDLE.SRCHINST[lang]} value={instName} onChange={this.onSearchByName.bind(this)} />
                </div>
                <div>
                    <label>{INSTDBBUNDLE.FILTERBYCNT[lang]}</label>
                    <Select

                        value={this.valueFromId(countryOptions, selectedCountry)}
                        onChange={this.handleCountrySelected}
                        options={countryOptions}
                        isSearchable={true}
                        placeholder={INSTDBBUNDLE.SLCTCNTRY[lang]}
                    />
                </div>
                <div>
                    <label>{INSTDBBUNDLE.FILTERBYTYP[lang]}</label>
                    <Select
                        value={this.valueFromId(typeOptions, selectedType)}
                        onChange={this.handleTypeSelected}
                        options={typeOptions}
                        isSearchable={true}
                        placeholder={INSTDBBUNDLE.SLCTTYP[lang]}
                    />
                </div>
                <div>
                    <label>{INSTDBBUNDLE.FILTERBYSCTR[lang]}</label>
                    <Select
                        value={this.valueFromId(sectorOptions, selectedSector)}
                        onChange={this.handleSectorSelected}
                        options={sectorOptions}
                        isSearchable={true}
                        placeholder={INSTDBBUNDLE.SLCTSCTR[lang]}
                    />
                </div>
                <div>
                    <label>{INSTDBBUNDLE.FILTERBYACTIVITY[lang]}</label>
                    <Select
                        value={this.valueFromId(activityOptions, selectedActivity)}
                        onChange={this.handleActivitySelected}
                        options={activityOptions}
                        isSearchable={true}
                        placeholder={INSTDBBUNDLE.SLCTACTIVITY[lang]}
                    />
                </div>
                <div>
                    {/* <a href="#" onClick={this.clearSearchCriteria.bind(this)}>clear</a> */}
                </div>
            </div>
        );
    }

    renderBody(institutions) {
        return(
            <div className={styles.institutionsTable}>
                {this.renderMetadata()}
                {<table>
                    <tbody>
                        {this.renderTableHeader()}
                        {institutions.length === 0 ? (
                            <tr className={styles.dataStatus}>
                                {this.state.dataLoaded
                                    ? <td colSpan="6">{INSTDBBUNDLE.NODATA[lang]}</td>
                                    : <td colSpan="6">
                                        <LoadingSpinner/>
                                      </td>
                                }
                            </tr>
                        ) :
                            (this.renderTableData())}
                    </tbody>
                </table>}
            </div>
        );
    }

    render() {
        const { institutions, dataLoaded } = this.state;

        return (
            <div>
                <Helmet
                    title="AQUASTAT - FAO's Global Information System on Water and Agriculture"
                    meta={[
                        { name: 'description', content: 'FAO AQUASTAT' },
                        { name: 'keywords', content: 'fao, water, aquastat, water production, Institutions Database' },
                    ]}
                />
                <Header siteTitle="AQUASTAT" location={{}} />
                <div className="app-wrapper">
                    <h2 className="site-title">AQUASTAT - FAO's Global Information System on Water and Agriculture</h2>
                    <TopMenu location="/databases/institutions-database" />
                    <div className={templateStyles.wrapper}>
                        <div className={templateStyles.subMenuWrapper}>
                            {this.renderSearchArea()}
                        </div>
                        {this.renderBody(institutions)}
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default InstitutionsDatabase;